import React from 'react';
import { Badge } from 'framework/ui/mui-builder';
import { COST_REPORT_SOURCE_OPTIONS } from './costReportSource';
import { ChipOwnProps } from '@mui/material';

type Props = {
  sourceType?: string | null;
  className?: string;
};

const SOURCE_COLORS: Record<string, ChipOwnProps['color']> = {
  MAIN: 'success',
  SANDBOX: 'warning',
};

const CostReportSourceBadge: React.FC<Props> = ({ sourceType, className }) => {
  const normalized = (sourceType || '').toUpperCase();
  const color = SOURCE_COLORS[normalized] ?? 'default';

  const base = COST_REPORT_SOURCE_OPTIONS[normalized as keyof typeof COST_REPORT_SOURCE_OPTIONS] ?? sourceType ?? '—';

  const label = `${base} report source`;

  return (
    <div className={`mm-source-row ${className ?? ''}`} style={{ marginBottom: 20 }}>
      <Badge color={color}>{label}</Badge>
    </div>
  );
};

export default CostReportSourceBadge;
